import { ReservationObjectType, ReservationStatusEnumType } from '../generated/graphql';

export function isReservationAvailable(reservation: ReservationObjectType): boolean {
  return reservation.unboxed
    ? reservation.status === ReservationStatusEnumType.Created
    : reservation.status === ReservationStatusEnumType.Reserved;
}

export function getReservationGroupKey(reservation: ReservationObjectType): string {
  const vendingKey = [...reservation.vendingProducts]
    .map((p) => `${p.product?._id ?? 'none'}:${p.amount}`)
    .sort()
    .join('|');
  const freeKey = [...reservation.freeProducts]
    .map((p) => `${p.product?._id ?? 'none'}:${p.amount}`)
    .sort()
    .join('|');

  return [
    vendingKey,
    freeKey,
    reservation.vendingTotalPrice,
    reservation.vendingDiscount ?? 0,
    reservation.status,
    reservation.unboxed,
  ].join('::');
}

export interface ReservationGroup {
  reservations: ReservationObjectType[];
}

export function groupReservations(reservations: ReservationObjectType[]): ReservationGroup[] {
  const groups = new Map<string, ReservationObjectType[]>();

  for (const reservation of reservations) {
    const key = getReservationGroupKey(reservation);
    const existing = groups.get(key) ?? [];
    existing.push(reservation);
    groups.set(key, existing);
  }

  return Array.from(groups.values()).map((groupReservations) => ({
    reservations: groupReservations,
  }));
}

export function findReservationGroup(
  reservations: ReservationObjectType[],
  reservationId: string
): ReservationGroup | undefined {
  return groupReservations(reservations).find((group) =>
    group.reservations.some((reservation) => reservation._id === reservationId)
  );
}

export function getAvailableReservationsInGroup(group: ReservationGroup): ReservationObjectType[] {
  return group.reservations.filter(isReservationAvailable);
}
